module.exports = __webpack_public_path__ + "media/images/menu-closed-91f49cb2.svg";